export class FeatureFlags {
  externalAuthenticationEnabled: boolean = false;
  disableMpnId: boolean = false;
}
